import { useMemo } from 'react'
import { usePortfolioHouseVisits } from '../../StateManagment/PortfolioHouseVisitsContext'
import { aggregateVisitsByProject } from '../../helpers/housevisitsPortfolio/aggregateHouseVisits'
import { buildCumulativeHoursSeries } from '../../helpers/dateHelpers/adressDashboard/tasksHours'
import CumulativeHoursLineChart from '../Visualisations/adresses/CumulativeHoursLineChart'
import StaticCardLabel from './StaticCardLabel'
import DashboardCardOptions from './DashboardCardOptions'
import CardHeaderInfoPopover from '../common/CardHeaderInfoPopover'
import ProjectContributionBreakdown from './housevisitsPortfolio/ProjectContributionBreakdown'
import DashboardCardEmptyState from './DashboardCardEmptyState'
import { CATEGORICAL } from '../../helpers/chartPalette'

// AI-CONTEXT: See docs/patterns.md#dashboard-static-card

const HOURS_COLUMNS = [
    { key: 'visitCount', label: 'Bezoeken' },
    { key: 'hours', label: 'Uren' },
]

/**
 * @param {object} props
 * @param {object} props.item - The DashboardItems doc backing this static card
 */
const DashboardPortfolioHouseVisitsHoursCard = ({ item }) => {
    const { projects, tasks, loading } = usePortfolioHouseVisits()
    // Vaste paletkleur. Deze kaart staat alleen op het dashboard, dus er valt
    // niets te kiezen; de opgeslagen ColorOverrides blijven in Firestore staan
    // maar worden niet meer gelezen. Zie docs/patterns.md#ui-chart-palette.
    const lineColor = CATEGORICAL[0]

    const cumulativeHoursData = useMemo(
        () => buildCumulativeHoursSeries(tasks),
        [tasks]
    )

    const breakdown = useMemo(() => (
        aggregateVisitsByProject(projects, tasks).map((row) => ({
            CompagnyID: row.CompagnyID,
            name: row.name,
            byColumn: {
                visitCount: row.visitCount,
                hours: row.hours,
            },
        }))
    ), [projects, tasks])

    const popoverContent = (
        <ProjectContributionBreakdown
            items={breakdown}
            columns={HOURS_COLUMNS}
            formatValue={(v) => (Number.isInteger(v) ? v : Number(v).toFixed(2))}
        />
    )

    const isEmpty = !loading && projects.length === 0

    return (
        <div className='housevisits-card-body'>
            <StaticCardLabel
                title='Cumulatieve uren (portfolio)'
                pill={{ variant: 'housevisits', label: 'Portfolio' }}
            />
            {!isEmpty && (
                <CardHeaderInfoPopover content={popoverContent} label='Bijdrage per project' />
            )}
            <div className='housevisits-card-chart'>
                {loading ? (
                    <p className='portfolio-breakdown-empty'>Data laden…</p>
                ) : isEmpty ? (
                    <DashboardCardEmptyState type='portfolio-housevisits-hours' />
                ) : (
                    <CumulativeHoursLineChart
                        data={cumulativeHoursData}
                        color={lineColor}
                        height={'100%'}
                    />
                )}
            </div>
            <DashboardCardOptions item={item} />
        </div>
    )
}

export default DashboardPortfolioHouseVisitsHoursCard
